import { ComponentProps } from "react";

import { ContentCard } from "./ContentCard";
import { HorizontalCard } from "./HorizontalCard";
import { VerticalFullCard } from "./VerticalFullCard";

export const OriginalContentCard = ({
    device,
    ...props
}: Omit<ComponentProps<typeof ContentCard>, "type">) => {
    const map = {
        "web+tablet": <VerticalFullCard {...props} />,
        app: <HorizontalCard {...props} />
    };

    return device ? (
        map[device]
    ) : (
        <>
            <VerticalFullCard className="hidden md:flex" {...props} />
            <HorizontalCard className="flex md:hidden" {...props} />
        </>
    );
};
